function createNullActor(id) {
  return {
    id: id,
    send: function send() {
      return void 0;
    },
    subscribe: function subscribe() {
      return {
        unsubscribe: function unsubscribe() {
          return void 0;
        }
      };
    },
    toJSON: function toJSON() {
      return {
        id: id
      };
    }
  };
}
/**
 * Creates a null actor that is able to be invoked given the provided
 * invocation information in its `.meta` value.
 *
 * @param invokeDefinition The meta information needed to invoke the actor.
 */


function createInvocableActor(invokeDefinition) {
  var tempActor = createNullActor(invokeDefinition.id);
  tempActor.meta = invokeDefinition;
  return tempActor;
}

function isActor(item) {
  try {
    return typeof item.send === 'function';
  } catch (e) {
    return false;
  }
}

export { createInvocableActor, createNullActor, isActor };